import { Seo } from 'modules/common/components/Seo/Seo'
import { useSelectSidebarMenu } from 'modules/common/components/Sidebar/hooks/useSelectSidebarMenu'
import { LayoutDashboard } from 'modules/common/components/_layouts/LayoutDashboard'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { BlankPage } from 'modules/common/types/page'
import {
  EnumSidebarMenu,
  EnumSidebarSubMenu,
} from 'modules/common/types/sidebar'
import { SponsorshipContainer } from 'modules/settings/components/sponsorship/SponsorshipContainer/SponsorshipContainer'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

export const SettingsSponsorshipPage: BlankPage = () => {
  const { t } = useTranslation('settings-page-sponsorship')

  useSelectSidebarMenu({
    menuId: EnumSidebarMenu.SETTINGS,
    subMenuId: EnumSidebarSubMenu.SETTINGS_SPONSORSHIP,
  })

  return (
    <>
      <Seo title={t('meta.title')} description={t('meta.description')} />
      <SponsorshipContainer />
    </>
  )
}

SettingsSponsorshipPage.getLayout = (page) => (
  <LayoutDashboard className="justify-center">{page}</LayoutDashboard>
)

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        'common',
        'common-components',
        'settings-page-sponsorship',
        'settings-components',
      ])),
    },
  }
}

SettingsSponsorshipPage.type = 'authenticated'

export default SettingsSponsorshipPage
